<template>
  <div :id="id" class="c-form-dropdown-field-wrapper">
		<validation-message
			:valid="valid"
			:invalid="invalid"
			:validationMessage="validationMessage"
		>
			<div class="c-form-dropdown-field">
				<text-field
					:label="inputLabel"
					id="input"
					:type="type"
					:disabled="disabled"
					:required="required"
					v-model="inputValue"
					@change="updateInputValue"
				/>
				<select-dropdown
					:label="selectLabel"
					id="select"
					:options="options"
					v-model="selectValue"
					@change="changeSelectValue"
				/>
			</div>
		</validation-message>

    <div v-if="tooltip" class="c-tooltip">
      <ToolTip :title="tooltipTitle" :isActive="isActiveTooltip" @toggleTooltip="(value) => $emit('toggleTooltip', value)">
        <span v-html="tooltipMessage"></span>
        <img v-if="tooltipImageUrl" class="test" width="84" height="117" :src="tooltipImageUrl" />
      </ToolTip>
    </div>


	</div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
import ToolTip from '../../../../components/consumer/_contact-us-rap/_vue/ToolTip.vue';
import TextField from '../../../../components/consumer/forms/input/TextField.vue';
import SelectDropdown from '../../../../components/consumer/forms/select/SelectDropdown.vue';
export default {
  components: { ValidationMessage, ToolTip, TextField, SelectDropdown },
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
		inputLabel: {
      required: true,
      type: String,
    },
		selectLabel: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
		disabled: {
      required: false,
      type: Boolean,
    },
    tooltip: {
      required: false,
      type: Boolean,
    },
    tooltipTitle: {
      required: false,
      type: String,
    },
		tooltipMessage:{
			required: false,
      type: String,
		},
    tooltipImageUrl: {
      required: false,
      default: '',
      type: String,
    },
    isActiveTooltip: {
      type: Boolean,
    },
    type: {
      default: 'text',
      required: false,
      type: String,
    },
    value: {
      type: [String, Number],
    },
		inputValue: {
      type: [String, Number],
    },
		selectValue: {
      type: [String, Number, null],
			default: null
    },
		options: {
      required: true,
      type: Array,
    },
		valid: {
      type: Boolean,
      default: null
    },
    invalid: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationMessage: {
      required: false,
      type: String,
    },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-textfield__label--required' : '';
    },
  },
  methods: {
    updateInputValue(value) {
			this.inputValue = value;
			this.$emit('onInputValue', value); 
		},
		changeSelectValue(value) {
      this.selectValue = value.value;
			this.$emit('onSelectValue', value); 
		},
  },
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/DropdownField.vue